import React, { useEffect, useState } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useStockAuth } from '../../context/StockAuthContext';
import { useStock } from '../../context/StockContext';

const B = '#0B3D6E', T = '#0F6E56';

export default function StockLayout() {
  const { user, logout } = useStockAuth();
  const { unreadAlerts, fetchAll } = useStock();
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => { fetchAll(); }, []); // eslint-disable-line

  const navItems = [
    { to:'/stock/dashboard', label:'Dashboard',  icon:'📊' },
    { to:'/stock/products',  label:'Produits',    icon:'📦' },
    { to:'/stock/movements', label:'Mouvements',  icon:'🔄' },
    { to:'/stock/alerts',    label:'Alertes',     icon:'🔔', badge:unreadAlerts },
    { to:'/stock/scanner',   label:'Scanner',     icon:'📷' },
  ];

  const isActive = to => location.pathname === to;
  const handleLogout = () => { logout(); navigate('/stock'); };

  return (
    <div style={{ minHeight:'100vh', background:'#f1f5f9', display:'flex', flexDirection:'column' }}>
      <header style={{ background:'#0f1f35', position:'sticky', top:0, zIndex:50 }}>
        <div style={{ display:'flex', alignItems:'center', padding:'0 1rem', height:54, gap:10 }}>

          {/* Brand */}
          <Link to="/stock/dashboard" style={{ display:'flex', alignItems:'center', gap:9, textDecoration:'none', flexShrink:0, marginRight:6 }}>
            <div style={{ width:32, height:32, background:B, borderRadius:8, display:'flex', alignItems:'center', justifyContent:'center' }}>
              <svg width="20" height="20" viewBox="0 0 40 40">
                <circle cx="20" cy="20" r="15" fill="none" stroke="white" strokeWidth="1.5" strokeDasharray="65 20"/>
                <rect x="14" y="17" width="12" height="6" rx="1.5" fill="white"/>
                <rect x="17" y="14" width="6" height="12" rx="1.5" fill={T}/>
              </svg>
            </div>
            <div style={{ lineHeight:1.15 }}>
              <div style={{ fontSize:12, fontWeight:600, color:'#fff' }}>StockMed</div>
              <div style={{ fontSize:9, color:'rgba(255,255,255,0.45)', textTransform:'uppercase', letterSpacing:'0.8px' }}>by LOMED MEDICARE</div>
            </div>
          </Link>

          {/* Desktop nav */}
          <nav style={{ display:'flex', gap:3, flex:1 }} className="stock-desktop-nav">
            {navItems.map(({ to, label, icon, badge }) => (
              <Link key={to} to={to} style={{ display:'flex', alignItems:'center', gap:6, padding:'7px 11px', borderRadius:8, textDecoration:'none', fontSize:13, position:'relative', background:isActive(to)?'rgba(255,255,255,0.12)':'transparent', color:isActive(to)?'#fff':'rgba(255,255,255,0.55)' }}>
                <span style={{ fontSize:14 }}>{icon}</span>{label}
                {badge > 0 && <span style={{ background:'#dc2626', color:'#fff', fontSize:9, fontWeight:700, width:16, height:16, borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', position:'absolute', top:4, right:4 }}>{badge}</span>}
              </Link>
            ))}
          </nav>

          <div style={{ display:'flex', alignItems:'center', gap:8, flexShrink:0 }} className="stock-desktop-nav">
            {/* Back to main app */}
            <Link to="/" style={{ display:'flex', alignItems:'center', gap:5, color:'rgba(255,255,255,0.6)', background:'rgba(255,255,255,0.07)', border:'none', padding:'6px 11px', borderRadius:8, fontSize:11, textDecoration:'none', whiteSpace:'nowrap' }}>
              <svg viewBox="0 0 24 24" style={{ width:12, height:12, fill:'none', stroke:'currentColor', strokeWidth:2 }}>
                <path d="M19 12H5M12 5l-7 7 7 7"/>
              </svg>
              App principale
            </Link>

            {user?.plan === 'free' && (
              <Link to="/stock/upgrade" style={{ background:'linear-gradient(135deg,#f59e0b,#d97706)', color:'#fff', padding:'5px 11px', borderRadius:7, fontSize:11, fontWeight:600, textDecoration:'none' }}>⭐ Pro</Link>
            )}
            {user?.plan === 'pro' && (
              <span style={{ background:'linear-gradient(135deg,#f59e0b,#d97706)', color:'#fff', padding:'4px 10px', borderRadius:7, fontSize:10, fontWeight:600 }}>⭐ PRO</span>
            )}

            <button onClick={handleLogout} style={{ display:'flex', alignItems:'center', gap:6, color:'rgba(255,255,255,0.6)', background:'rgba(255,255,255,0.07)', border:'none', padding:'6px 12px', borderRadius:8, fontSize:12, cursor:'pointer' }}>
              <svg viewBox="0 0 24 24" style={{ width:12, height:12, fill:'none', stroke:'currentColor', strokeWidth:2 }}>
                <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9"/>
              </svg>
              {user?.username}
            </button>
          </div>

          <button onClick={()=>setMenuOpen(!menuOpen)} className="stock-mobile-nav" style={{ background:'rgba(255,255,255,0.1)', border:'none', borderRadius:7, padding:'6px 8px', cursor:'pointer', display:'flex', flexDirection:'column', gap:4 }}>
            <span style={{ display:'block', width:18, height:2, background:'rgba(255,255,255,0.8)', borderRadius:2 }}/>
            <span style={{ display:'block', width:18, height:2, background:'rgba(255,255,255,0.8)', borderRadius:2 }}/>
            <span style={{ display:'block', width:18, height:2, background:'rgba(255,255,255,0.8)', borderRadius:2 }}/>
          </button>
        </div>

        {menuOpen && (
          <div style={{ background:'#162234', borderTop:'1px solid rgba(255,255,255,0.08)', padding:'8px' }}>
            {navItems.map(({ to, label, icon, badge }) => (
              <Link key={to} to={to} onClick={()=>setMenuOpen(false)} style={{ display:'flex', alignItems:'center', gap:10, padding:'10px 12px', borderRadius:8, textDecoration:'none', fontSize:14, marginBottom:2, position:'relative', background:isActive(to)?'rgba(255,255,255,0.12)':'transparent', color:isActive(to)?'#fff':'rgba(255,255,255,0.65)' }}>
                <span>{icon}</span>{label}
                {badge>0 && <span style={{ background:'#dc2626', color:'#fff', fontSize:9, fontWeight:700, padding:'1px 6px', borderRadius:10, marginLeft:'auto' }}>{badge}</span>}
              </Link>
            ))}
            <Link to="/" onClick={()=>setMenuOpen(false)} style={{ display:'flex', alignItems:'center', gap:8, padding:'10px 12px', borderRadius:8, textDecoration:'none', fontSize:13, color:'rgba(255,255,255,0.6)', marginBottom:4 }}>
              ← App principale (LOMED MEDICARE)
            </Link>
            <button onClick={handleLogout} style={{ width:'100%', background:'rgba(255,255,255,0.07)', border:'none', color:'rgba(255,255,255,0.65)', padding:'10px', borderRadius:8, fontSize:13, cursor:'pointer', textAlign:'left' }}>
              🚪 Déconnexion ({user?.username})
            </button>
          </div>
        )}
      </header>

      <main style={{ flex:1 }}><Outlet/></main>

      <style>{`
        @media(min-width:700px){.stock-desktop-nav{display:flex !important}.stock-mobile-nav{display:none !important}}
        @media(max-width:699px){.stock-desktop-nav{display:none !important}.stock-mobile-nav{display:flex !important}}
      `}</style>
    </div>
  );
}

